import { sendAsyncAction } from '../core/async.js';

var UserGraphicsQualityPresetTypes;
(function (UserGraphicsQualityPresetTypes) {
    UserGraphicsQualityPresetTypes["LOW"] = "low";
    UserGraphicsQualityPresetTypes["MEDIUM"] = "medium";
    UserGraphicsQualityPresetTypes["HIGH"] = "high";
})(UserGraphicsQualityPresetTypes || (UserGraphicsQualityPresetTypes = {}));
const PRESET_BY_CODE = {
    2: UserGraphicsQualityPresetTypes.HIGH,
    1: UserGraphicsQualityPresetTypes.MEDIUM,
    0: UserGraphicsQualityPresetTypes.LOW,
};
function getCodeCpuScore(cpuScore) {
    if (cpuScore >= 600000) {
        return 2;
    }
    if (cpuScore < 600000 && cpuScore >= 250000) {
        return 1;
    }
    return 0;
}
function getCodeGpuScore(gpuScore) {
    if (gpuScore >= 5800) {
        return 2;
    }
    if (gpuScore < 5800 && gpuScore >= 1600) {
        return 1;
    }
    return 0;
}
// https://jira.wargaming.net/browse/WSCLANS-7391
function getClientSettings() {
    return sendAsyncAction({ actionId: "getClientSettings" }).then((response) => {
        const { settings, hardware } = response.data;
        const isLowBySettings = settings.low_quality_gui || !settings.web_browser_hardware_acceleration;
        if (isLowBySettings) {
            response.data.preset = UserGraphicsQualityPresetTypes.LOW;
        }
        else {
            response.data.preset = PRESET_BY_CODE[Math.min(...[getCodeCpuScore(hardware.cpu_score), getCodeGpuScore(hardware.gpu_score)])];
        }
        return response;
    });
}

export { PRESET_BY_CODE, UserGraphicsQualityPresetTypes, getClientSettings, getCodeCpuScore, getCodeGpuScore };
//# sourceMappingURL=getClientSettings.js.map
